module.exports = __webpack_public_path__ + "static/img/da35ca9918eb957c2e6a20baeab9251d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service_jiagou.png
// module id = DRtR
// module chunks = 1